module.exports = __webpack_public_path__ + "img/traveller.a3a30976.svg";